// src/plugins/customIcons.js
import palaFrontalIcon from '@/views/Componente/Icono/palaFrontalIcon.vue';

// Si luego tenés más íconos SVG Vue, los importás aquí.
// Por ejemplo:
// import camiónMixerIcon from '@/views/Componente/Icono/camionMixerIcon.vue';
// import retroExcavadoraIcon from '@/views/Componente/Icono/retroExcavadoraIcon.vue';

export const customIcons = {
  palaFrontal: palaFrontalIcon,
  logoWC: '/icons/ISO_ColorAlta_100.ico', // Ruta pública (acordate de dejar el .ico en /public/icons/)
};
